import { removeVietnameseChars } from "../string/removeVietnameseChars";

const searchTypeMapping: {
  [key: string]: string[];
} = {
  resort: [
    "resort", "res", "resrt", "esort", "rsort", "resot", "resor",
    "sort", "rort", "rert", "rest", "reso",
    "retreat", "etreat", "rtreat", "rereat", "reteat", "retrat", "retret", "retrea",
    "treat", "rreat", "reeat", "retat", "retrt", "retre",
    "holiday", "oliday", "hliday", "hoiday", "holday", "holiay", "holiay", "holidy", "holida",
    "liday", "hiday", "hoday", "holay", "holiy", "holid",
    'khudu', 'khu du', "khunghi", "khu nghi", "nghi mat", "nghimat",
    'khu d', 'khu', 'kh'
  ],
  villa: [
    "villa", "illa", "vlla", "vila", "vill",
    "lla", "vla", "via", "vil",
    "home", "ome", "hme", "hoe", "hom",
    "bietthu", "biet thu", "biet", "thu",
  ],
  apartment: [
    "apartment", "partment", "aartment", "aprtment", "apatment", "aparment", "apartent", "apartmnt", "apartmet", "apartmen",
    "artment", "artment", "aptment", "apament", "aparent", "apartnt", "apartmt", "apartme",
    "apt",
    "flat",
    "condo",
    "condominium", "ondominium", "cndominium", "codominium", "conominium", "condminium", "condoinium", "condomnium", "condominum", "condominim", "condominiu",
    "ndominium", "cdominium", "coominium", "conminium", "condinium", "condonium", "condomium", "condominm", "condomini",
    "can ho", "canho", "chungcu", "chung cu"
  ],
  homestay: [
    "homestay", "omestay", "hmestay", "hoestay", "homstay", "hometay", "homesay", "homesty", "homesta",
    "mestay", "hestay", "hostay", "homtay", "homeay", "homesy", "homest",
    "stay", "tay", "say", "sty", "sta",
    "guest", "uest", "gest", "gust", "guet", "gues",
    "est", "gst", "gut", "gue",
    "house", "ouse", "huse", "hose", "houe", "hous",
    "use", "hse", "hoe", "hou",
    "bnb", "bb",
    "nha nghi dan dung", "nhanghidadung",
    "luu tru tai nha dan", "luutrutainhadan",
    "can ho", "canho", "chungcu", "chung cu"
  ],
  boutique: [
    "boutique", "botique", "boutiqe", "boutqu", "boutiq",
    "small hotel",
    "luxury hotel", "luxry hotel", "luxur hotel",
    "khach san nho", "khachsannho",
    "khach",
    "san",
    "ks",
  ],
  hotel: [
    "hotel", "hote", "hoel", "htel", "otel", "hotl",
    "lodge", "lodg", "loge", "ldge",
    "hostel", "ostel", "hstel", "hosel", "hostl", "hoste",
    "motel", "mote", "motel",
    "khach",
    "san",
    "nghi",
    "ks",
    "tro",
    "khach san", "khachsan",
    "nha nghi", "nhanghi",
    "nha tro", "nhatro"
  ],
  destination: [
    "destination", "destinaton", "destnation", "destinatin", "desination",
    "place", "plac", "plae", "pace",
    "spot", "spt", "sot",
    "location", "locaton", "locatin", "locaton",
    "travel", "trave", "travel spt", "travelpot",
    "tourist", "touris", "tourst",
    "diem",
    "dia",
    "noi",
    "tham",
    "quan",
    "diem du",
    "diem den", "diemden",
    "dia diem", "diadiem",
    "diem du lich", "diemdulich",
    "noi tham quan", "noithamquan"
  ]
};
export const getSearchTypeLocationByValue = (value: string) => {
  const lowerCaseValue = removeVietnameseChars(value).toLowerCase();

  const searchTypes = Object.keys(searchTypeMapping);

  const filteredTypes = searchTypes
    .filter(
      type => searchTypeMapping[type].some(str => lowerCaseValue.includes(str))
    ).join(',');

  if (filteredTypes === 'destination') {
    return searchTypes.join(',');
  }


  return undefined // filteredTypes || searchTypes.join(',');
}